import EventBusContextProvider from '@/context/eventBusContext';
import envConfig from './config/env';
import { WebSocketProvider } from './context/websocketContext';
import { HashRouter } from 'react-router-dom';
import { RouterInterceptor } from './router';
import { ThemeProvider } from './components/ThemeProvider';
import { BoomWalletProvider } from '@boomeme/wallet-sdk';
import './lang';
import './style/global.css';
import './style/variable.css';
import './style/view.transition.css';
import './style/app.css';
import 'swiper/css';

export default () => {
  return (
    <ThemeProvider storageKey="theme">
      <BoomWalletProvider appId={envConfig.VITE_BOOM_APP_ID} clientId={envConfig.VITE_BOOM_CLIENT_ID}>
        <EventBusContextProvider>
          <WebSocketProvider>
            <HashRouter>
              <RouterInterceptor />
            </HashRouter>
          </WebSocketProvider>
        </EventBusContextProvider>
      </BoomWalletProvider>
    </ThemeProvider>
  );
};
